// @core/api/endpoints/payment/update_payment_policy.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  PaymentPolicyResponse,
  UpdatePaymentPolicyRequest,
} from '../../../types/payment';

const BASE_PATH = '/payment';

/**
 * Update payment policy
 * Updates an existing payment policy with the provided data. Returns the updated resource.
 */
export async function UpdatePaymentPolicy(
  policy_id: string,
  data: UpdatePaymentPolicyRequest,
  options?: RequestOptions
): Promise<PaymentPolicyResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/payment-policies/:policy_id`;
  requestPath = requestPath.replace(':policy_id', encodeURIComponent(policy_id));
  const requestOptions = options;
  return client.put<PaymentPolicyResponse>(requestPath, data, requestOptions);
}
